/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_steps_profile = /** @type {(inputs: {}) => string} */ () => {
	return `Perfil`
};

const en_onboarding_steps_profile = /** @type {(inputs: {}) => string} */ () => {
	return `Profile`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_steps_profile = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_steps_profile(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_steps_profile", locale)
	if (locale === "es") return es_onboarding_steps_profile(inputs)
	return en_onboarding_steps_profile(inputs)
};
export { onboarding_steps_profile as "onboarding.steps.profile" }